import React from "react"
import { Control, useWatch } from "react-hook-form"
import { getElementType } from "../../elementTypes"
import { BadgeElementFormValues } from "./BadgeSidePanelForm"

type ElementFieldsProps = {
  control: Control<BadgeElementFormValues>
  eventId: string
  /** Several elements are selected. */
  group?: boolean
}

/** The fields of the element type in the form, if there's one type. */
const ElementSpecificFields = ({ control, eventId, group = false }: ElementFieldsProps) => {
  const data = useWatch({ control })
  const { selectedBlockType: type } = data

  const definition = type ? getElementType(type) : undefined
  if (!definition) return null
  const { Fields } = definition

  return <Fields control={control} eventId={eventId} group={group} />
}

export default ElementSpecificFields
